import React from "react"

const PaginationItem = ({ children, className, href, disabled, active}) => {
  className = `page-item${className ? ` ${className}` : ''} ${disabled ? ` disabled`:''}${active ? 'active':''}`
  return <li className={className}><a className="page-link" href={href}>{children}</a></li>
}
export default PaginationItem
